export const getSubaggregationName = (config, subkey) => `${config.property}_${config.aggregation}_${subkey}`;